// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"fd3b0b8d","430":"b30ed4ff","669":"56cc5839","888":"dc544f1e"}[chunkId] + ".chunk.js";
};